import axios from "axios";

import storage from '../utils/storage';

import { BASEURL } from "./_constantes";

import alertInformacao from "src/components/UI/AlertInformacao";

export const execute = async (rota, method, data, params = {}) => {

    const { beforeSend, onCompleted, onSuccess, onError, alertError = true, setLoading, responseType = 'json' } = params;

    const AUTHORIZATION = `Bearer ${storage.get('token')}`;    

    let response = null;

    if (beforeSend) {
        beforeSend();
    }

    if (setLoading) {
        setLoading(true);
    }    
    
    try {

        response = await axios({
            url: BASEURL + rota,
            method: method,
            data: data,
            responseType: responseType,
            headers: {
                Authorization: AUTHORIZATION,
                versao: process.env.REACT_APP_VERSAO_SISTEMA
            }
        });

        if (onSuccess) {
            onSuccess(response);
        }        

    } catch (error) {   

        response = error.response;
        
        if (onError) {
            onError(response);
        } else if (alertError) {
            alertInformacao({icon: "error", title: "Erro", text: response.data });
        }  
    }

    if (onCompleted) {
        onCompleted(response);
    }

    if (setLoading) {
        setLoading(false);
    }    
}
